const { css } = require('tailant')

export default css
